'use strict';

import {fnErrorMsg, printResponse} from "../jquery-functions-library";
import {element_exists} from "../functions";

export var fnPaySlipDelete = function () {

    var tableName = '#datatable-existing-payrolls';

    if (!element_exists(tableName)) return false;

    var btnDelete = '.btn-delete-pay-slip';

    $(document).off('click', btnDelete);
    $(document).on('click', btnDelete, createDeletePaySlipForm);

    function createDeletePaySlipForm(e) {
        e.preventDefault();

        const rowData = JSON.parse($(tableName).DataTable().row($(this).parents('tr')).data().payslip);

        var lang = allLangFiles.salary.pay_slips.js;

        $.confirm({
            title: lang.delete.title,
            content: lang.delete.content,
            theme: 'supervan',
            columnClass: 'col-md-12',
            backgroundDismiss: true,
            buttons: {
                Ja: {
                    action: function () {

                        $.ajax({
                            method: 'POST',
                            data: rowData,
                            url: '/salary/pay-slips/delete',
                            success: function (response) {

                                printResponse(response);
                                $(tableName).DataTable().ajax.reload(null, false);
                            },
                            error: fnErrorMsg
                        });
                    },
                    text: lang.yes
                },
                Nej: {
                    text: lang.no,
                }
            }
        });
    }
};